import { render, staticRenderFns } from "./CmsDetail.vue?vue&type=template&id=1ad7ff3f&scoped=true"
import script from "./CmsDetail.vue?vue&type=script&lang=js"
export * from "./CmsDetail.vue?vue&type=script&lang=js"
import style0 from "./CmsDetail.vue?vue&type=style&index=0&id=1ad7ff3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad7ff3f",
  null
  
)

export default component.exports